var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _circle6, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxTimeline2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 163,
    viewBox: "0 0 15 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 155.5,
    r: 7.5,
    fill: "#e8eaed"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8242 153.004C11.9368 153.117 12 153.269 12 153.429C12 153.588 11.9368 153.74 11.8242 153.853L7.32458 158.353C7.26512 158.412 7.19452 158.459 7.11682 158.491C7.03912 158.524 6.95584 158.54 6.87174 158.54C6.78763 158.54 6.70435 158.524 6.62665 158.491C6.54895 158.459 6.47835 158.412 6.41889 158.353L4.18327 156.117C4.12594 156.062 4.0802 155.996 4.04874 155.923C4.01728 155.849 4.00072 155.771 4.00002 155.691C3.99933 155.611 4.01452 155.532 4.0447 155.458C4.07489 155.384 4.11947 155.317 4.17583 155.261C4.2322 155.205 4.29923 155.16 4.373 155.13C4.44678 155.1 4.52583 155.085 4.60554 155.085C4.68525 155.086 4.76403 155.103 4.83727 155.134C4.91051 155.165 4.97676 155.211 5.03213 155.269L6.87154 157.108L10.975 153.004C11.0307 152.948 11.0969 152.904 11.1698 152.874C11.2426 152.844 11.3207 152.828 11.3996 152.828C11.4785 152.828 11.5566 152.844 11.6294 152.874C11.7023 152.904 11.7685 152.948 11.8242 153.004Z",
    fill: "#9ca3af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 84V147",
    stroke: "#e8eaed"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 76.5,
    r: 7.5,
    fill: "#1a2b5f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.125,
    cy: 76.125,
    r: 1.125,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 76.125,
    r: 1.125,
    fill: "#ffffff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.875,
    cy: 76.125,
    r: 1.125,
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15V71",
    stroke: "#1a2b5f"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#1a2b5f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H4.5C4.35834 8 4.23967 7.952 4.144 7.856C4.04834 7.76 4.00034 7.64134 4 7.5C3.99967 7.35867 4.04767 7.24 4.144 7.144C4.24034 7.048 4.359 7 4.5 7H7V4.5C7 4.35834 7.048 4.23967 7.144 4.144C7.24 4.04834 7.35867 4.00034 7.5 4C7.64134 3.99967 7.76017 4.04767 7.8565 4.144C7.95284 4.24034 8.00067 4.359 8 4.5V7H10.5C10.6417 7 10.7605 7.048 10.8565 7.144C10.9525 7.24 11.0003 7.35867 11 7.5C10.9997 7.64134 10.9517 7.76017 10.856 7.8565C10.7603 7.95284 10.6417 8.00067 10.5 8H8V10.5C8 10.6417 7.952 10.7605 7.856 10.8565C7.76 10.9525 7.64134 11.0003 7.5 11C7.35867 10.9997 7.24 10.9517 7.144 10.856C7.048 10.7603 7 10.6417 7 10.5V8Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxTimeline2);
export default __webpack_public_path__ + "static/media/tx-timeline2.ea12a36d2fac8e3d68b7b67046415a19.svg";
export { ForwardRef as ReactComponent };